$(document).ready(function() {


    //in viewport 
	
		//columns
		var $h2 = $('h2');
        var $richtext = $('.rich-text__text');
		var $aside = $('section#shopify-section-template--21115362377816__main');
		var $aside2 = $('section#shopify-section-template--21114345422936__main');
        var $img = $('img');
		var $window = $(window);
		
    
    function check_if_in_view() {
		  var window_height = $window.height();
		  var window_top_position = $window.scrollTop();
		  var window_bottom_position = (window_top_position + window_height);
			
			//animations box
			$.each($h2, function() {
			var $element = $(this);
			var element_height = $element.outerHeight();
			var element_top_position = $element.offset().top;
			var element_bottom_position = (element_top_position + element_height);

			
			if ((element_bottom_position >= window_top_position) &&
				(element_top_position <= window_bottom_position)) {
			  $element.addClass('fadein');
			} 
		  });


          $.each($richtext, function() {
			var $element = $(this);
			var element_height = $element.outerHeight();
			var element_top_position = $element.offset().top;
			var element_bottom_position = (element_top_position + element_height);

			
			if ((element_bottom_position >= window_top_position) &&
				(element_top_position <= window_bottom_position)) {
			  $element.addClass('fadein');
			} 
		  });


           $.each($img, function() {
			var $element = $(this);
			var element_height = $element.outerHeight();
			var element_top_position = $element.offset().top;
			var element_bottom_position = (element_top_position + element_height);

			
			if ((element_bottom_position >= window_top_position) &&
				(element_top_position <= window_bottom_position)) {
			  $element.addClass('fadein');
			} 
		  });

		   $.each($('#join'), function() {
			var $element = $(this);
			var element_height = $element.outerHeight();
			var element_top_position = $element.offset().top;
			var element_bottom_position = (element_top_position + element_height);

			
			if ((element_bottom_position >= window_top_position) &&
				(element_top_position <= window_bottom_position)) {
			  	$aside.fadeOut(1000);
				$aside2.fadeOut(1000);
			} else{
				$aside.show();
				$aside2.show();
			}
		  });
		
			
		}

		$window.on('scroll resize', check_if_in_view);
		$window.trigger('scroll');












     $('#additional-guest').on('change', function() {
        if ($(this).prop('checked')) {
            $('.add-guest-fields').show();
        } else {
            $('.add-guest-fields').hide();
        }
    });
});